import { Box, Typography } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { useRef, useState } from "react";
import _ from "lodash";

interface DropdownButtonProps {
    onChange: (value: any) => void;
    options: Array<{ name: string; value: any }>;
    disabled?: boolean;
    title?: string;
    direction?: 'up' | 'down'; // 👈 เลือกทิศทางการแสดง dropdown
}

export default function DropdownButton(props: DropdownButtonProps) {
    ////-------------------
    ////    REF
    ////-------------------
    const ref = useRef<HTMLDivElement | null>(null);

    ////-------------------
    ////    STATE
    ////-------------------
    const [isOpen, setIsOpen] = useState(false);

    ////-------------------
    ////    EVENT HANDLER
    ////-------------------
    const handleOnChange = (value: any) => {
        props.onChange(value);
        setIsOpen(false);
    };

    const handleOnClick = () => {
        if (!props.disabled) {
            setIsOpen(!isOpen);
        }
    };

    return (
        <Box position="relative">
            <Box display="flex" flexDirection="row">
                <Box
                    onClick={handleOnClick}
                    borderRadius="4px"
                    border={1}
                    height="40px"
                    display="flex"
                    alignItems="center"
                    paddingX="10px"
                    justifyContent="center"
                    gap="8px"
                    sx={{
                        cursor: props.disabled ? 'not-allowed' : 'pointer',
                        color: props.disabled ? '#808080' : "#1CB99A",
                        borderColor: props.disabled ? '#BBBBBB' : "#1CB99A",
                        backgroundColor: props.disabled ? '#F0F0F0' : 'white',
                    }}
                >
                    <Typography fontSize="16px">{props.title}</Typography>
                    {isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </Box>
            </Box>

            {isOpen && (
                <Box
                    ref={ref}
                    position="absolute"
                    width="100%"
                    bgcolor="white"
                    border={1}
                    borderColor="#E5E5E5"
                    borderRadius="4px"
                    paddingY="8px"
                    zIndex={50}
                    {...(props.direction === 'up'
                        ? { bottom: '100%', mb: 1 }
                        : { top: '100%', mt: 1 }
                    )}
                >
                    {_.map(props.options, (item, index) => (
                        <Box
                            key={index}
                            onClick={() => handleOnChange(item.value)}
                            paddingX="16px"
                            height="40px"
                            display="flex"
                            alignItems="center"
                            fontSize="16px"
                            sx={{
                                "&:hover": {
                                    backgroundColor: '#EBF2F0',
                                },
                                cursor: 'pointer',
                            }}
                        >
                            {item.name}
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
}
